import isNil from 'lodash/isNil'

import { Dialog } from '@/components/ui/dialog'
import { Progress } from '@/components/ui/progress'
import { unescapeHtmlText } from '@/modules/chatting/ui/chat-window/fan-info/utils'

import { DialogProps } from '../types'
import { useProgress } from './useProgress'

interface Props extends DialogProps {
  listId: number
  listName: string
}

export const OpenChatsListCreationProgressDialog = ({
  isOpen,
  onClose,
  listId,
  listName,
}: Props) => {
  const { progress, completed, success, failure, total } = useProgress(listId)

  return (
    <Dialog
      show={isOpen}
      onClose={onClose}
    >
      <Dialog.Header>
        <Dialog.Title>List creation progress</Dialog.Title>
      </Dialog.Header>
      <Dialog.Description>
        {completed ? (
          <h3 className="mt-3 text-center text-title">
            The list{' '}
            <span className="font-semibold">
              {unescapeHtmlText(listName ?? '')}
            </span>{' '}
            has been created and{' '}
            <span className="font-semibold">{success} fans</span> have
            successfully been added to it.
          </h3>
        ) : (
          <>
            <div className="mb-4 mt-6 flex justify-between text-center text-sm text-title">
              {!isNil(success) && !isNil(failure) && !isNil(total) && (
                <span>
                  {success + failure}/{total}
                </span>
              )}
              <span>{progress}%</span>
            </div>

            <Progress value={progress} />
          </>
        )}
      </Dialog.Description>
      <Dialog.ClosableFooter
        onClose={onClose}
        className="block"
        buttonClassName="w-full"
        closeText={completed ? 'Close' : 'Run in background'}
      />
    </Dialog>
  )
}
